import { css } from '@emotion/react'
import { Color } from 'csstype'

export default function shadowIcon(color: Color) {
  return css`
    filter: drop-shadow(0 0.08rem 0.1rem ${color});
  `
}
